//?import statements
import Card from "./Components/UI/Card";
import questions from "./data";
import Questions from "./Components/Questions/Questions";
//? styles
import "./App.css";

const App = () => {
  const lastUpdate = "23rd August 2022";
  return (
    <Card className="container">
      <h2 className="header">
        Questions And Answers About Login
      </h2>
      <Questions questions={questions} />
      <p id="last-update">Last Updated: <span>{lastUpdate}</span></p>
    </Card>
  );
};

export default App;
